import { FC } from "react";

interface CardTextProps {
  titleText: string;
  descriptionText?: string;
  backgroundColor?: string;
  textColor?: string;
  ratio: string;
}

const CardText: FC<CardTextProps> = ({ titleText, descriptionText, backgroundColor, textColor, ratio }) => {
  return (
    <div
      className={`flex h-CardGallery md:h-CardGalleryDesktop ${ratio === "3:4" ? "aspect-3-4" : "aspect-4-3"} font-secondary rounded-lg p-s items-center`}
      style={{ backgroundColor: backgroundColor, color: textColor }}
    >
      <div className="w-full pb-xl pt-xl">
        <p className="font-primary text-l md:text-xl whitespace-break-spaces mx-auto font-normal text-left pb-s uppercase accent-font accent-title">
          {titleText}
        </p>
        {descriptionText && <p className="text-m mx-auto font-medium  text-left">{descriptionText}</p>}
      </div>
    </div>
  );
};
export default CardText;
